import React from 'react';
import { useGroup } from '../../contexts/GroupContext';
import './GroupSelector.css';

const GroupSelector = () => {
  const { groups, selectedGroup, selectedGroupId, selectGroup, loading } = useGroup();

  if (loading) {
    return <div className="group-selector-loading">Loading groups...</div>;
  }

  if (groups.length === 0) {
    return <div className="group-selector-empty">No groups available</div>;
  }

  if (groups.length === 1) {
    return (
      <div className="group-selector-single">
        <span className="group-badge">{selectedGroup?.name || 'Default Group'}</span>
      </div>
    );
  }

  return (
    <div className="group-selector">
      <label htmlFor="group-select" className="group-select-label">
        Group:
      </label>
      <select
        id="group-select"
        className="group-select"
        value={selectedGroupId || ''}
        onChange={(e) => {
          const value = e.target.value;
          if (value === '') {
            selectGroup(null);
          } else {
            const groupId = parseInt(value);
            selectGroup(groupId);
          }
        }}
      >
        <option value="">All Groups</option>
        {groups.map((group) => (
          <option key={group.id} value={group.id}>
            {group.name} {group.customer ? `(${group.customer.name})` : ''}
          </option>
        ))}
      </select>
    </div>
  );
};

export default GroupSelector;

